import React from 'react';

const ManufacturingFloorVisualization = () => {
  return (
    <div className="w-full h-80 relative overflow-hidden rounded-lg bg-gradient-to-br from-slate-900 to-slate-800">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 320"
        className="absolute inset-0"
      >
        <defs>
          <linearGradient id="stationGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#374151" />
            <stop offset="100%" stopColor="#1f2937" />
          </linearGradient>
          
          <filter id="glow">
            <feGaussianBlur stdDeviation="2"/>
          </filter>
        </defs>
        
        {/* Assembly Station */}
        <g transform="translate(300, 90)">
          <rect width="200" height="140" rx="8" fill="url(#stationGrad)" stroke="#4b5563" strokeWidth="1"/>
          
          {/* Work surface */}
          <rect x="15" y="15" width="170" height="110" rx="4" fill="#1f2937" stroke="#6b7280" strokeWidth="1"/>
          
          {/* Component areas */}
          <rect x="25" y="25" width="35" height="20" rx="2" fill="#374151" stroke="#10b981" strokeWidth="1"/>
          <text x="42" y="37" textAnchor="middle" fill="#10b981" fontSize="10" fontFamily="system-ui" fontWeight="500">Parts A</text>
          
          <rect x="140" y="25" width="35" height="20" rx="2" fill="#374151" stroke="#10b981" strokeWidth="1"/>
          <text x="157" y="37" textAnchor="middle" fill="#10b981" fontSize="10" fontFamily="system-ui" fontWeight="500">Parts B</text>
          
          <rect x="25" y="100" width="30" height="20" rx="2" fill="#374151" stroke="#f59e0b" strokeWidth="1"/>
          <text x="40" y="112" textAnchor="middle" fill="#f59e0b" fontSize="10" fontFamily="system-ui" fontWeight="500">Tools</text>
          
          {/* Assembly area */}
          <rect x="70" y="60" width="60" height="25" rx="3" fill="#374151" stroke="#06b6d4" strokeWidth="2"/>
          <text x="100" y="75" textAnchor="middle" fill="#06b6d4" fontSize="10" fontFamily="system-ui" fontWeight="500">Workpiece</text>
          
          <rect x="145" y="100" width="30" height="20" rx="2" fill="#374151" stroke="#8b5cf6" strokeWidth="1"/>
          <text x="160" y="112" textAnchor="middle" fill="#8b5cf6" fontSize="10" fontFamily="system-ui" fontWeight="500">QC</text>
          
          <text x="100" y="155" textAnchor="middle" fill="#e5e7eb" fontSize="14" fontFamily="system-ui" fontWeight="600">
            Assembly Workstation
          </text>
        </g>
        
        {/* Current inefficient movement path - appears first */}
        <path d="M 340 125 Q 310 100 325 115 Q 340 130 355 150 Q 370 170 420 130 Q 450 110 470 125 Q 485 140 445 155 Q 420 170 390 160 Q 360 150 350 140 Q 340 130 340 125" 
              stroke="rgba(239, 68, 68, 0.6)" 
              strokeWidth="2" 
              fill="none"
              strokeDasharray="500"
              strokeDashoffset="500">
          <animate attributeName="stroke-dashoffset" 
                   values="500;0;0;0;500;500;500;500" 
                   dur="20s" 
                   repeatCount="indefinite"/>
        </path>
        
        {/* Optimized path - appears much later, after red disappears */}
        <path d="M 340 115 L 400 140 L 445 155 L 400 140 L 340 115" 
              stroke="rgba(16, 185, 129, 0.8)" 
              strokeWidth="2" 
              fill="none"
              opacity="0">
          <animate attributeName="opacity" 
                   values="0;0;0;0;0;0;1;1;0;0" 
                   dur="20s" 
                   repeatCount="indefinite"/>
        </path>
        
        {/* Worker following current path */}
        <circle r="5" fill="#06b6d4" filter="url(#glow)">
          <animateMotion dur="15s" repeatCount="indefinite" begin="2s">
            <path d="M 340 125 Q 310 100 325 115 Q 340 130 355 150 Q 370 170 420 130 Q 450 110 470 125 Q 485 140 445 155 Q 420 170 390 160 Q 360 150 350 140 Q 340 130 340 125"/>
          </animateMotion>
          <animate attributeName="opacity" values="0;0;1;1;1;0;0;0;0;0" dur="20s" repeatCount="indefinite"/>
        </circle>
        
        {/* Camera with field of view */}
        <g transform="translate(400, 40)">
          <rect x="-10" y="-5" width="20" height="10" rx="2" fill="#374151" stroke="#06b6d4" strokeWidth="1"/>
          <circle cx="0" cy="0" r="2" fill="#06b6d4">
            <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
          </circle>
          
          {/* Camera field of view */}
          <path d="M -8 5 L -120 80 L 120 80 L 8 5 Z" fill="rgba(6, 182, 212, 0.08)" opacity="0.6"/>
        </g>
        
        {/* Dynamic status text */}
        <g transform="translate(400, 280)">
          <rect x="-200" y="-20" width="400" height="40" rx="8" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.4)" strokeWidth="1"/>
          
          {/* Phase 1: Analyzing */}
          <text x="0" y="-2" textAnchor="middle" fill="#06b6d4" fontSize="16" fontFamily="system-ui" fontWeight="600">
            <animate attributeName="opacity" values="1;1;1;1;0;0;0;0;0;0" dur="20s" repeatCount="indefinite"/>
            MotionLogic® analysing workflow...
          </text>
          
          {/* Phase 2: Optimizing */}
          <text x="0" y="-2" textAnchor="middle" fill="#10b981" fontSize="16" fontFamily="system-ui" fontWeight="600">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0;1;1;0" dur="20s" repeatCount="indefinite"/>
            Walking Path Optimised — 40% more efficient
          </text>
          
          {/* Phase 3: Ready */}
          <text x="0" y="-2" textAnchor="middle" fill="#8b5cf6" fontSize="16" fontFamily="system-ui" fontWeight="600">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0;0;0;1" dur="20s" repeatCount="indefinite"/>
            Ready to implement improvements
          </text>
        </g>
      </svg>
    </div>
  );
};

export default ManufacturingFloorVisualization;